import { useEffect, useRef } from "react";
import { FoamTree as FoamTreeImpl } from "@carrotsearch/foamtree";
import { Box } from "@mui/material";
import { RootState } from "../../../redux/store";
import useAppSelector from "../../../hooks/useAppSelector";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { setTreemapGroups } from "../../../redux/slices/search";
import {
  HIGH_CONFIDENCE_SCORE,
  MEDIUM_CONFIDENCE_SCORE,
  VERY_HIGH_CONFIDENCE_SCORE,
} from "../../../utils/constants";

function Treemap() {
  const searchState = useAppSelector((state: RootState) => state.search);
  const dispatch = useAppDispatch();
  const data = searchState.clusters.map((cluster: string, idx: number) => {
    const queryGroup = searchState.queryResult.filter(
      (qr) => searchState.clusters[qr.cluster] === cluster
    );
    return {
      id: idx.toString(),
      label: `${cluster} (${queryGroup.length})`,
      weight: queryGroup.length,
      groups: queryGroup.map((element, idx2) => {
        return {
          id: `${idx}.${idx2}`,
          label: element.answer,
          score: element.score,
        };
      }),
    };
  });
  const element = useRef(null);
  const foamtree = useRef(null);
  useEffect(() => {
    foamtree.current = new FoamTreeImpl({
      rainbowStartColor: "hsl(3, 65%, 48%)",
      rainbowEndColor: "hsl(277, 45%, 60%)",
      groupLabelMaxFontSize: 40,
      element: element.current,
      pixelRatio: window.devicePixelRatio || 1,
      dataObject: {
        groups: data,
      },
      groupColorDecorator: function (opts: any, params: any, vars: any) {
        const score = params.group.score;
        if (score > VERY_HIGH_CONFIDENCE_SCORE) {
          vars.groupColor.l = 1;
        } else if (score > HIGH_CONFIDENCE_SCORE) {
          vars.groupColor.l = 30;
        } else if (score > MEDIUM_CONFIDENCE_SCORE) {
          vars.groupColor.l = 60;
        } else if (score > 0) {
          vars.groupColor.l = 80;
        }
        vars.groupColor.model = "hsl";
      },
      onGroupClick: function (event: any) {
        dispatch(setTreemapGroups(event["group"]));
      },
    });
    return () => {
      if (foamtree.current) {
        (foamtree.current as any).dispose();
      }
    };
  }, [searchState.queryResult]);

  return <Box ref={element} height="100%" width="100%" />;
}

export default Treemap;
